import Axios from "axios";
import { router } from '../router'

import authService from "../services/AuthService";
import appointmentService from "../services/AppointmentService";
import studioService from "../services/StudioService";
import appointmentTypeService from "../services/AppointmentTypeService";
import roleService from "../services/RoleService";
import instrumentService from "../services/InstrumentService";
import userService from "../services/UserService";
import reportService from "../services/ReportService";
import failureService from "../services/FailureService";
import membershipFeeService from "../services/MembershipFeeService";


let apiUrl = "https://mors-api.azurewebsites.net/";

// let apiUrl = "http://localhost:49950/";

// let apiUrl = "https://morsdemo.azurewebsites.net/";


// let apiUrl = "https://api.mostarrockschool.org/";


// Axios Configuration
Axios.defaults.headers.common.Accept = "application/json";

Axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers['Authorization'] = getTokenWithPrefix();
  // config.headers['Content-Type'] = 'application/json';
  // config.headers.common.Accept = "application/json";
  return config;
}, function (error) {
  console.log(error);
  // Do something with request error
  return Promise.reject(error);
});

Axios.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  const { status } = error.response;
  if (status === 401 || status === 403) {
    router.push('/');
  }

  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});

function getTokenWithPrefix() {
  let token = localStorage.getItem("user-token");
  if (token) {
    return `Bearer ${token}`;
  } else {
    return '';
  }
};

export default {
  authService: new authService(Axios, apiUrl),
  appointmentService: new appointmentService(Axios, apiUrl),
  studioService: new studioService(Axios, apiUrl),
  appointmentTypeService: new appointmentTypeService(Axios, apiUrl),
  roleService: new roleService(Axios, apiUrl),
  instrumentService: new instrumentService(Axios, apiUrl),
  userService: new userService(Axios, apiUrl),
  reportService: new reportService(Axios, apiUrl),
  failureService: new failureService(Axios, apiUrl),
  membershipFeeService: new membershipFeeService(Axios, apiUrl),

  setAxiosHeader() {
    //Token header configuration
    Axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("user-token")}`;
  },
  resetAxiosHeader() {
    Axios.defaults.headers.common[
      "Authorization"
    ] = "";
  },
  getTokenWithPrefix() {
    let token = localStorage.getItem("user-token");
    if (token) {
      return `Bearer ${token}`;
    } else {
      return '';
    }
  },
  checkRole(role) {
    var hasRole = false;
    var roles = localStorage.getItem("user-roles").split(",");
    roles.forEach(r => {
      if (r == role) {
        hasRole = true;
        return;
      }
    });
    return hasRole;
  }
};
